<template>
  <router-view/>
</template>

<style lang="scss">
@import '~@/sass/main.scss';

#app {
  font-family: '微软雅黑', 'Source Sans Pro', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

body {
  margin: 0;
  // background: var(--va-background) !important;
  background: #f4f6f8!important;
}
</style>
